import { useState, useEffect } from 'react';

const navItems = [
  { label: 'ホーム', href: '#home' },
  { label: 'サロンについて', href: '#about' },
  { label: '施術メニュー', href: '#services' },
  { label: 'お客様の声', href: '#reviews' },
  { label: 'アクセス', href: '#access' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="cursor-pointer">
          <div className="flex flex-col leading-none">
            <span
              className={`text-xl font-light tracking-[0.3em] transition-colors duration-300 ${
                scrolled ? 'text-stone-800' : 'text-white'
              }`}
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Relax Moonseed
            </span>
            <span
              className={`text-xs tracking-[0.25em] mt-0.5 transition-colors duration-300 ${
                scrolled ? 'text-stone-500' : 'text-white/80'
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              リラクゼーションサロン
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className={`text-sm tracking-widest transition-all duration-300 cursor-pointer relative group ${
                scrolled ? 'text-stone-600 hover:text-stone-900' : 'text-white/90 hover:text-white'
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-current transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href="#booking"
            onClick={(e) => handleNavClick(e, '#booking')}
            className={`whitespace-nowrap text-sm tracking-widest px-6 py-2.5 rounded-full border transition-all duration-300 cursor-pointer ${
              scrolled
                ? 'border-stone-700 text-stone-700 hover:bg-stone-700 hover:text-white'
                : 'border-white/80 text-white hover:bg-white hover:text-stone-800'
            }`}
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            ご予約
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          className={`md:hidden cursor-pointer ${scrolled ? 'text-stone-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md shadow-lg">
          <div className="px-8 py-6 flex flex-col gap-5">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="text-stone-700 text-sm tracking-widest cursor-pointer"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={(e) => handleNavClick(e, '#booking')}
              className="whitespace-nowrap text-sm tracking-widest px-6 py-2.5 rounded-full border border-stone-700 text-stone-700 text-center cursor-pointer hover:bg-stone-700 hover:text-white transition-all"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              ご予約
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
